<template>
  <v-container class="pa-0 mx-0" style="min-width: 100%">

    <v-row class="primary-bg align-center" style="height: 150px;">
      <v-col class="mt-4 ml-4">
        <v-btn prepend-icon="mdi-arrow-left" to="/">{{ lang.datenschutz.back_to_home_link }}</v-btn>
      </v-col>
    </v-row>

    <v-row class="mx-4 my-12 justify-center">
      <v-col cols="12" md="10">
        <h1 class="text-h4 mb-6">{{ lang.datenschutz.privacy_policy_label }}</h1>

        <p v-html="lang.datenschutz.privacy_policy_content"></p>

        <h2 class="text-h6 mt-6 mb-2">1. {{ lang.datenschutz.contact_us_label }}</h2>
        <p v-html="lang.datenschutz.contact_us_content"></p>

        <h2 class="text-h6 mt-6 mb-2">2. {{ lang.datenschutz.your_rights_label }}</h2>
        <p v-html="lang.datenschutz.your_rights_content"></p>

        <h2 class="text-h6 mt-6 mb-2">3. {{ lang.datenschutz.cookies_label }}</h2>
        <p v-html="lang.datenschutz.cookies_content"></p>

        <h2 class="text-h6 mt-6 mb-2">4. {{ lang.datenschutz.web_analytics_label }}</h2>
        <p v-html="lang.datenschutz.web_analytics_content"></p>

        <h2 class="text-h6 mt-6 mb-2">5. {{ lang.datenschutz.use_of_google_services_label }}</h2>
        <p v-html="lang.datenschutz.use_of_google_services_content"></p>

        <h2 class="text-h6 mt-6 mb-2">6. {{ lang.datenschutz.responsible_person_label }}</h2>
        <p v-html="lang.datenschutz.responsible_person_content"></p>

        <h2 class="text-h6 mt-6 mb-2">7. {{ lang.datenschutz.changes_label }}</h2>
        <p v-html="lang.datenschutz.changes_content"></p>
      </v-col>
    </v-row>

    <contactSection></contactSection>

  </v-container>
</template>

<script>
import lang from '@/lang/lang.js'
import contactSection from "@/components/contactSection.vue";
import {useHead} from "@vueuse/head";

export default {
  setup() {
    useHead({
      title: 'Datenschutz – DM Energieberatung',
      link: [
        { rel: 'canonical', href: 'https://www.dm-energieberatung.de/datenschutz' }
      ]
    })
  },
  components: {
    contactSection,
  },
  data() {
    return {
      lang: lang
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>